import $ from 'jquery'
import DkMapsManager from 'map/js/map'
import {DkMap} from 'map/js/map'

$(function() {
   const maps = new DkMapsManager().triggerInitialized()

   $(window).on('ariaAccordion.slideDown', function(event, panel) {
      $(".map-container", panel).each(function(key, newMap){
         try{
            new DkMap(newMap);
         }
         catch(error) {
           //console.error(error);
         }
      });
   });
});